module.exports = __webpack_public_path__ + "static/img/btn_xunren_nor.29582fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/btn_xunren_nor.png
// module id = dBcv
// module chunks = 1